import {FC, useEffect} from 'react';
import {Box, Icon, Typography} from '@mui/material';
import {Field, Form, Formik, FormikHelpers} from 'formik';
import {initialValues, validationSchema} from './formConfiguration';
import Button from '@/shared/components/Button';
import Input from '@/shared/components/Inputs/Input';
import {useAppDispatch} from '@/store/hooks';
import {ADD_PHONE_NUMBER, BODY1, ENTER_PHONE_NUMBER, FIELD, H5, SUBMIT, SUBTITLE1} from '@/utils/constants';
import {ReactComponent as TrashIcon} from '@/assets/icons/trash-icon.svg';
import {
  organizationAddVipPhone,
  organizationDeleteVipPhone,
  organizationGetVipPhones,
} from '@/store/organization-notificationSetting/actions';
import {useSelector} from 'react-redux';
import {vipNotificationsStyle} from './VIPNotification.style';
import {getAllPhoneNumbersSelector} from '@/store/organization-notificationSetting';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {useGetOrganizationId} from '@/utils/hooks';

const VIPNotification: FC = () => {
  const vipPhonesData = useSelector(getAllPhoneNumbersSelector);
  const organizationId = useGetOrganizationId();
  const dispatch = useAppDispatch();

  const handleDeleteVipPhone = async (valuePhone: number) => {
    try {
      await dispatch(organizationDeleteVipPhone(valuePhone)).unwrap();
      if (organizationId) await dispatch(organizationGetVipPhones(organizationId)).unwrap();
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

  const handleSubmit = async (values: {number: string}, {resetForm}: FormikHelpers<{number: string}>) => {
    if (organizationId) {
      try {
        await dispatch(organizationAddVipPhone({organizationId, phoneNumber: values.number})).unwrap();
        resetForm();
      } catch (error) {
        toast.error(getErrorMessage(error));
      }
    }
  };

  useEffect(() => {
    if (organizationId) {
      const getOrganizationVipPhones = async () => {
        try {
          await dispatch(organizationGetVipPhones(organizationId)).unwrap();
        } catch (error) {
          toast.error(getErrorMessage(error));
        }
      };

      getOrganizationVipPhones();
    }
  }, []);

  return (
    <Box sx={vipNotificationsStyle.wrapper}>
      <Box>
        <Typography sx={vipNotificationsStyle.title} variant={H5}>
          Phone Numbers for VIP Notifications
        </Typography>
        <Typography sx={vipNotificationsStyle.afterTitle} variant={BODY1}>
          Add phone numbers to which VIP notifications will be sent
        </Typography>

        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
          <Box component={Form} sx={vipNotificationsStyle.inputWrapper}>
            <Field
              id={FIELD.number}
              name={FIELD.number}
              placeholder={ENTER_PHONE_NUMBER}
              component={Input}
              sx={vipNotificationsStyle.input}
            />
            <Button type={SUBMIT} title={ADD_PHONE_NUMBER} sx={vipNotificationsStyle.button} />
          </Box>
        </Formik>

        <Box sx={vipNotificationsStyle.phoneWrapper}>
          {vipPhonesData.map((phone) => (
            <Box key={phone.id} sx={vipNotificationsStyle.phoneItem}>
              <Typography variant={SUBTITLE1}>{phone.number}</Typography>
              <Icon onClick={() => handleDeleteVipPhone(phone.id)} sx={vipNotificationsStyle.trashIcon}>
                <TrashIcon />
              </Icon>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default VIPNotification;
